<script lang="ts">
  /** A text with `{name}` placeholders whose values are shown bold: the sentence stays one text. */
  interface Props {
    text: string;
    values: Record<string, string | number>;
  }

  const { text, values }: Props = $props();

  const Parts = $derived(text.split(/(\{\w+\})/));

  function getValue(part: string): string | number | undefined {
    return /^\{\w+\}$/.test(part) ? values[part.slice(1, -1)] : undefined;
  }
</script>

{#each Parts as part, index (index)}
  {@const Value = getValue(part)}
  {#if Value === undefined}{part}{:else}<strong>{Value}</strong>{/if}
{/each}
